export default "__VITE_ASSET__CEfbxGHT__"